import {CURRENCY_DATA} from '@functions/const/currencyData.js';

export function getCurrencySymbol(currencyCode) {
  if (!currencyCode) return '';
  return (CURRENCY_DATA[currencyCode] && CURRENCY_DATA[currencyCode].symbol) || currencyCode;
}
